import type { OwaDate } from 'owa-datetime';
import type { DateRange } from 'owa-datetime-utils';
import { action } from 'satcheljs';
import type { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

export const loadDayGrid = action(
    'loadDayGrid',
    (
        scenario: string,
        initialDate: OwaDate,
        focusTimeDateRange: DateRange | null,
        folderIds: string[],
        enableDragDrop: boolean,
        enableUpNext: boolean,
        numDaysInDayRange?: number,
        dateRangeType?: DateRangeType | undefined,
        weekViewPixelsPerMinuteRatio?: number
    ) => ({
        scenario,
        initialDate,
        focusTimeDateRange,
        folderIds,
        enableDragDrop,
        enableUpNext,
        numDaysInDayRange,
        dateRangeType,
        weekViewPixelsPerMinuteRatio,
    })
);

export const selectDayGridDate = action(
    'selectDayGridDate',
    (scenario: string, newDate: OwaDate) => ({
        scenario,
        newDate,
    })
);
